import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_HOST_INSURANCE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

// Seguro de Responsabilidad Civil del anfitrión: coste fijo que se descuenta del
// payout del anfitrión (line item negativo, includeFor ['provider']). Solo se
// muestra en la vista del anfitrión; el bañista no lo ve porque no está en su
// payin. El importe vive en el servidor (fuente de verdad); aquí solo se muestra.
const LineItemHostInsuranceMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const insuranceLineItem = lineItems.find(
    item => item.code === LINE_ITEM_HOST_INSURANCE && !item.reversal
  );

  if (!isProvider || !insuranceLineItem) {
    return null;
  }

  const total = insuranceLineItem.lineTotal;
  const formattedTotal = total instanceof Money ? formatMoney(intl, total) : null;

  return formattedTotal ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.hostInsurance" />
      </span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  ) : null;
};

LineItemHostInsuranceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemHostInsuranceMaybe;
